import { FunctionComponent } from 'react'
import { Button, Spinner, Table } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import PersonCell from 'components/ui/personCell'
import StatusBadge, { BadgeTone } from 'components/ui/statusBadge'
import { AccessRequest, AccessRequestStatus } from '../types'

const STATUS_TONE: Record<string, BadgeTone> = {
  APPROVED: 'success',
  REQUESTED: 'warning',
  DENIED: 'danger',
  REVOKED: 'danger',
  NOT_REQUESTED: 'neutral',
}

export type AccessRequestAction = 'approve' | 'deny'

type AccessRequestsTableProps = {
  accessRequests: AccessRequest[]
  onApprove: (accessRequestId: number) => void
  onDeny: (accessRequestId: number) => void
  /** Request currently being updated, used to show the loading state. */
  updating: { id: number; action: AccessRequestAction } | null
}

const AccessRequestsTable: FunctionComponent<AccessRequestsTableProps> = ({
  accessRequests,
  onApprove,
  onDeny,
  updating,
}) => (
  <div className="table-wrap">
    <Table hover>
      <thead>
        <tr>
          <th>Médico</th>
          <th>Acesso</th>
          <th className="actions-col">
            <span className="visually-hidden">Ações</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {accessRequests.map((accessRequest, index) => {
          const isUpdating = (action: AccessRequestAction) =>
            updating?.id === accessRequest.id && updating.action === action

          return (
            <tr key={index}>
              <td>
                <PersonCell name={accessRequest.doctorName} />
              </td>
              <td>
                <StatusBadge
                  tone={STATUS_TONE[String(accessRequest.status)] ?? 'neutral'}
                >
                  {AccessRequestStatus[accessRequest.status]}
                </StatusBadge>
              </td>
              <td className="actions-col">
                <div className="row-actions">
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => onApprove(accessRequest.id)}
                  >
                    {isUpdating('approve') ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <Icon name="check" size={14} />
                    )}
                    Aprovar acesso
                  </Button>
                  <button
                    type="button"
                    className="row-action is-danger"
                    onClick={() => onDeny(accessRequest.id)}
                  >
                    {isUpdating('deny') ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <Icon name="x" size={14} />
                    )}
                    Negar acesso
                  </button>
                </div>
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  </div>
)

export default AccessRequestsTable
